import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Heart, Award, Users } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const SponsorsPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const sponsors = [
    {
      name: "AD (Atelier d'Architecture)",
      logo: "https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/kn0yrdmc_AD%20Carrelage.png",
      category: "Architecture"
    },
    {
      name: "Babourg Invest SA",
      logo: "https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/lvxfv0e7_Babourg%20Invest%20SA.png",
      category: "Finance"
    },
    {
      name: "BC (Bâtiment Carrelage)",
      logo: "https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/o0chfm8f_BC.png",
      category: "Construction"
    },
    {
      name: "JP Haenggeli",
      logo: "https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/nbl2avll_JP%20Haenggeli.png",
      category: "Services"
    },
    {
      name: "La Cave de Cheyres",
      logo: "https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/yrpnpbik_La%20Cave%20de%20Cheyres.png",
      category: "Gastronomie"
    },
    {
      name: "Décotterd & Bulliard Chauffage",
      logo: "/sponsors/decotterd.png",
      category: "Chauffage"
    },
    {
      name: "JPF",
      logo: "/sponsors/jpf.svg",
      category: "Construction"
    },
    {
      name: "Guisolan SA",
      logo: "/sponsors/guisolan.png",
      category: "Construction"
    },
    {
      name: "La Mobilière",
      logo: "https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/4xveiyu2_La%20Mobili%C3%A8re.png",
      category: "Assurance"
    },
    {
      name: "Pillonel Thermique",
      logo: "https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/i3aicnyk_Pillonel%20Thermique.png",
      category: "Chauffage"
    },
    {
      name: "Seydoux Grains",
      logo: "https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/h2v7858l_Seydoux%20Grains.png",
      category: "Commerce"
    },
    {
      name: "BCF",
      logo: "/sponsors/bcf.png",
      category: "Banque"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Nos Sponsors
            </h1>
            <p className="text-xl text-gray-600">
              Merci à nos partenaires qui soutiennent le club
            </p>
          </div>

          {/* Message de remerciement */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-10 rounded-3xl mb-16">
            <div className="flex items-start gap-4 mb-6">
              <Heart className="w-12 h-12 text-green-600 flex-shrink-0" />
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Un grand merci à nos sponsors !</h2>
                <p className="text-gray-700 leading-relaxed text-lg">
                  Grâce au soutien de nos sponsors et partenaires, le TC Cheyres-Châbles peut continuer 
                  à offrir des installations de qualité et organiser des événements tout au long de l'année. 
                  Leur engagement est essentiel pour le développement du club et la promotion du tennis dans notre région.
                </p>
              </div>
            </div>
          </div>

          {/* Grille des sponsors */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-16">
            {sponsors.map((sponsor, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all hover:scale-105 flex items-center justify-center"
              >
                <img 
                  src={sponsor.logo}
                  alt={sponsor.name}
                  className="w-full h-32 object-contain"
                />
              </div>
            ))}
          </div>

          {/* Devenir sponsor */}
          <div className="bg-gray-900 text-white p-12 rounded-3xl">
            <div className="flex items-center mb-6">
              <Award className="w-12 h-12 mr-4" />
              <h2 className="text-3xl font-bold">Devenir sponsor</h2>
            </div>
            <p className="text-gray-300 mb-8 text-lg">
              Votre entreprise souhaite soutenir le TC Cheyres-Châbles et gagner en visibilité ? 
              Rejoignez nos partenaires et bénéficiez d'une exposition auprès de nos membres et visiteurs.
            </p>
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="bg-white/10 p-6 rounded-xl">
                <h4 className="font-bold text-lg mb-2">Visibilité</h4>
                <p className="text-gray-300 text-sm">
                  Logo sur notre site web et nos supports de communication
                </p>
              </div>
              <div className="bg-white/10 p-6 rounded-xl">
                <h4 className="font-bold text-lg mb-2">Réseau</h4>
                <p className="text-gray-300 text-sm">
                  Accès à notre réseau de membres et partenaires
                </p>
              </div>
              <div className="bg-white/10 p-6 rounded-xl">
                <h4 className="font-bold text-lg mb-2">Engagement</h4>
                <p className="text-gray-300 text-sm">
                  Soutien au sport local et à la jeunesse
                </p>
              </div>
            </div>
            <button 
              onClick={() => setIsContactModalOpen(true)}
              className="inline-block bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold transition-all hover:scale-105"
            >
              Nous contacter pour un partenariat
            </button>
          </div>
        </div>
      </div>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />

      <Footer />
    </div>
  );
};

export default SponsorsPage;